import { io } from 'socket.io-client';
import { getToken } from './utils';

// A single shared connection to the /chat namespace (unlike the ad-hoc
// per-page `io()` in LiveCodingRoom.js) — every component that cares about
// chat events subscribes to this one socket instead of opening its own.
let socket = null;

const socketUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl && /^https?:\/\//i.test(apiUrl)) {
    return new URL(apiUrl).origin;
  }
  if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
    return window.location.origin;
  }
  return `http://localhost:${process.env.REACT_APP_BACKEND_PORT || '5000'}`;
};

/** Connects (or reconnects with a fresh token) the shared /chat socket. */
export const connectChatSocket = () => {
  const token = getToken();
  if (!token) return null;

  if (socket) {
    if (socket.auth?.token === token && socket.connected) return socket;
    socket.auth = { token };
    if (!socket.connected) socket.connect();
    return socket;
  }

  socket = io(`${socketUrl()}/chat`, {
    auth: { token },
    transports: ['websocket', 'polling'],
  });
  return socket;
};

export const disconnectChatSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getChatSocket = () => socket;
